import { planningAPI } from "../../axios"
export const actions = {
    CreateBudgetProposalTemplate(context, data) {
        return planningAPI.post("BudgetProposalTemplate/Add", data);
    },
    GetSingleBudgetProposalTemplate(context, id) {
        return planningAPI.get(`BudgetProposalTemplate/${id}`);
    },
    GetAllBudgetProposalTemplates() {
        return planningAPI.get("BudgetProposalTemplate/All");
    },
    UpdateBudgetProposalTemplate(context, data) {
        return planningAPI.put(`BudgetProposalTemplate/Update/${data.id}`, data);
    },
    GetActiveBudgetProposalTemplate(context, data) {
        return planningAPI.get(`BudgetProposalTemplate/Active/Campus/${data}`);
    },
    RemoveBudgetProposalTemplate(context, id) {
        return planningAPI.delete(`BudgetProposalTemplate/Remove/${id}`);
    },
    GetPostedProposals(context, id) {
        return planningAPI.get(`BudgetProposalTemplate/Posted/DeliveryUnit/${id}`);
    }
}